<template>
    <div
        class="protrait-detail-wrapper"
        v-show="content.length > 0"
        @mouseenter.stop="mouseOnView"
        @mouseleave.stop="mouseOutView"
        :style="{ top: positionTop, left: positionLeft }"
    >
        <div class="view-title">{{ $t("zhiji.knowlege.userPortrait") }}</div>
        <div class="view-content scroll-tracker">
            <div class="content-item" v-for="(item, idx) in content" :key="idx">
                <div class="item-name">{{ item.name }}：</div>
                <div class="item-detail">
                    <p v-for="(detail, idex) in item.value" :key="idex">{{ detail.label }}|{{ detail.value }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PortraitDetail",
    props: ["content", "positionTop", "positionLeft"],
    methods: {
        mouseOnView() {
            this.$emit("onview");
        },
        mouseOutView() {
            this.$emit("outview");
        }
    }
};
</script>

<style lang="less" scoped>
.protrait-detail-wrapper {
    margin-bottom: 16px;
    width: 277px;
    background: #fff;
    position: absolute;
    z-index: 1;
    top: 64px;
    left: 5px;
    border-radius: 4px;
    box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);

    .view-title {
        background: #e3edf6;
        padding: 8px;
    }

    .view-content {
        padding: 8px;
        max-height: 400px;
        overflow-y: auto;

        .item-name {
            position: relative;
            font-size: 14px;
            box-sizing: border-box;
            padding: 5px 0px 5px;
            background: #fff;
        }

        .item-detail {
            padding: 0px 30px 10px;
            border-bottom: 1px solid #d8e4f0;
        }
    }
}
</style>
